// extracted by mini-css-extract-plugin
export default {"wrapper":"IndicatorHeader_wrapper__NLx5W","scoreCustomSize":"IndicatorHeader_scoreCustomSize__LQK8l","gaugeContainer":"IndicatorHeader_gaugeContainer__pJXNi"};